// extracted by css-extract-rspack-plugin
export default {"button":"_facaeb4e","disabled":"_fe4bffe8","primaryButton":"_af178582"};